import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container, Snackbar } from '@mui/material';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Alert from 'src/components/Alert';
import { CONSTANTS, STRINGS } from 'src/commons';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import TrainerForm from 'src/components/trainer/TrainerForm';
import { addUpdateTrainer } from 'src/api/trainer';

const AddTrainer = () => {
  const { startLoading, stopLoading } = loaderReducerAction;
  const dispatch = useDispatch();
  const { user ,gymId } = useSelector((state) => state.common);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: '',
    severity: ''
  });

  const history = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarState({
      ...snackbarState,
      open: false
    });
  };

  return (
    <>
      <Helmet>
        <title>Trainers | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginTop: '2rem'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              name: '',
              email: '',
              mobileNumber: '',
              gender: 0,
              address: '',
              experience: null,
              remarks: '',
              profilePic: null
            }}
            validationSchema={CONSTANTS.trainerValidationSchema}
            onSubmit={async (values) => {
              try {
                const formData = new FormData();
                formData.append('name', values.name);
                formData.append('email', values.email);
                formData.append('phone', values.mobileNumber);
                formData.append('gender', values.gender);
                formData.append('address', values.address);
                formData.append('experience', values.experience);
                formData.append('remarks', values.remarks);
                formData.append('gym_id',gymId);
                if (values.profilePic) {
                  formData.append('profile_pic', values.profilePic);
                }

                dispatch(startLoading());
                const res = await addUpdateTrainer(user, formData);
                dispatch(stopLoading());
                const isError = res.status !== 200;
                setSnackbarState({
                  open: true,
                  message: res.message,
                  severity: isError ? 'error' : 'success'
                });
                if (!isError) {
                  history(CONSTANTS.ROUTES.PRIVATE_ROUTES.TRAINER);
                }
              } catch (err) {
                dispatch(stopLoading());
                setSnackbarState({
                  open: true,
                  message: err.message,
                  severity: 'error'
                });
              }
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              touched,
              values
            }) => (
              <TrainerForm
                errors={errors}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                touched={touched}
                values={values}
                heading={STRINGS.ADD_TRAINER}
              />
            )}
          </Formik>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarState.open}
            autoHideDuration={3000}
            onClose={handleClose}
          >
            <div>
              <Alert onClose={handleClose} severity={snackbarState.severity}>
                {snackbarState.message}
              </Alert>
            </div>
          </Snackbar>
        </Container>
      </Box>
    </>
  );
};

export default AddTrainer;
